import { trigger, style, state } from '@angular/animations';

export const contactSlideText = trigger('contactSlideText', [
    state('false', style({ "marginTop": '0px', "fontSize": '{{bigFontSize}}px', "border": "none" }),
        { params: { bigFontSize: 115 } }),
    state('true', style({ "marginTop": '{{marginTop}}px', "fontSize": '{{smallFontSize}}px', "border": "2px solid white", "border-radius": "4px" }),
        { params: { smallFontSize: 36, marginTop:350 } }),
]);